module.exports = __webpack_public_path__ + "img/9791158881658.7c9c8b27.jpg";